import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import PulseLoader from "react-spinners/BarLoader";
import mapboxgl from "mapbox-gl";
import { getDateFormat } from "@utils/datePickerUtils";
import ClipLoader from "react-spinners/ClipLoader";
import "mapbox-gl/dist/mapbox-gl.css";
import {
  Image,
  CustomCheckBox,
  DropdownWithSearch,
  Button,
} from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import { handleApiError } from "@utils/errorHandler";
import { addressSingleLine } from "@utils/utils";
import UserInfo from "@utils/UserInfo";
import ClientFilter from "./MapFilters/ClientFilter";
import SiteFilter from "./MapFilters/SiteFilter";
import SupplierFilter from "./MapFilters/SupplierFilter";
import ProductFilter from "./MapFilters/ProductFilter";
import { siteStatus, siteStatusColor } from "@utils/filterOptions";
import greyIcon from "@icons/ic-grey-arrow.svg";
import blueCloseArrowIcon from "@icons/ic-blue-close-arrow.svg";
import mapBlueIcon from "@icons/ic-map-marker-blue.svg";
import mapOrangeIcon from "@icons/ic-map-marker-orange.svg";
import mapSiteIcon from "@icons/site-map-icon.png";
import mapCenterIcon from "@icons/center-map-icon.png";
import {
  countryflagIcons as flagIcons,
  defaultCountryFlag,
} from "@utils/country-data";
import {
  MapContainerSection,
  MapContainerOuter,
  MapContainer,
  FilterOuter,
  MainTitle,
  FilterTitle,
  GridRow,
  FitlerOuterDiv,
  Title,
  FlexRow,
  labelStyles,
  FilterContainer,
  ContainerLabel,
  ButtonWrapper,
  FitlerInnerDiv,
  BorderImage,
  GridLoaderItem,
} from "./GeneralMap.styled";
import "./GeneralMap.scss";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

/**
 * Map,
 * Path - /general/map
 * @see See [Map Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3665526785/Map+search+page)
 * @component
 */
const GeneralMap = (props) => {
  const { t } = props;
  const mapContainer = useRef(null);

  const generalParams = useGetGeneralParameters();
  const { countryList } = generalParams;
  const countryId = UserInfo.countryId();

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [mapDataAPIError, setMapDataAPIError] = useState("");
  const [selectedClient, setSelectedClient] = useState([]);
  const [selectedSite, setSelectedSite] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [productList, setProductList] = useState([]);
  // const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [mapData, setMapData] = useState([]);
  const [entityType, setEntityType] = useState(["site", "centre"]);
  const [serviceType, setServiceType] = useState([]);
  const [countryIdList, setCountryIdList] = useState([countryId]);
  const [platfromCountryList, setPlatfromCountryList] = useState(
    UserInfo.countryListForFilter(t)
  );

  const [selectedSiteStatus, setSelectedSiteStatus] = useState([
    {
      label: t("SITE_STATUS_QUOTATION"),
      value: 1,
    },
    {
      label: t("SITE_STATUS_QUOTE_SENT"),
      value: 2,
    },
    {
      label: t("SITE_STATUS_WON"),
      value: 3,
    },
    {
      label: t("SITE_STATUS_READY_TO_START"),
      value: 12,
    },
    {
      label: t("SITE_STATUS_IN_PROGRESS"),
      value: 13,
    },
  ]);
  const [isFilterOpen, setFilterOpen] = useState(false);
  const entityTypeOptions = [
    {
      name: "MAP_FILTER_ENTITY_TYPE_SITES",
      id: "site",
    },
    {
      name: "MAP_FILTER_ENTITY_TYPE_CENTRES",
      id: "centre",
    },
  ];
  const serviceTypeOptions = [
    {
      name: t("REMOVAL"),
      value: "EVACUATION",
    },
    { name: t("SUPPLY"), value: "DELIVERY" },
    { name: t("OTHER"), value: "NONE" },
  ];

  useEffect(() => {
    if (Object.keys(generalParams).length > 0) {
      setSubCategoryList(generalParams.subCategoryList);
    }
  }, [generalParams]);

  const getBorderColor = (countryId) => {
    let color = "solid 2px #EDEDED";
    const countryIndex = countryIdList.indexOf(countryId);
    if (countryIndex >= 0) {
      color = "solid 2px #00AEEA";
    }
    return color;
  };

  const onCountryUpdate = (countryId) => {
    const countryIds = countryIdList;
    const countryIndex = countryIdList.indexOf(countryId);
    if (countryIndex === -1) {
      countryIds.push(countryId);
    }
    if (countryIndex >= 0) {
      countryIds.splice(countryIndex, 1);
    }
    setCountryIdList([...countryIds]);
  };

  const onEntityClick = (e, id) => {
    const entiryArray = entityType;
    if (entiryArray.indexOf(id) === -1 && e.currentTarget.checked)
      entiryArray.push(id.toString());
    else {
      const index = entiryArray.indexOf(id);
      if (index >= 0) {
        entiryArray.splice(index, 1);
      }
    }
    setEntityType([...entiryArray]);
  };

  const onServiceClick = (e, id) => {
    const serviceArray = serviceType;
    if (serviceArray.indexOf(id) === -1 && e.currentTarget.checked)
      serviceArray.push(id);
    else {
      const index = serviceArray.indexOf(id.toString());
      if (index >= 0) {
        serviceArray.splice(index, 1);
      }
    }
    setServiceType([...serviceArray]);
  };

  const onSiteStatusChange = (filter) => {
    setSelectedSiteStatus(filter);
  };

  const onSubCategoryChange = (filter) => {
    setSelectedSubCategory(filter);
  };

  const toggleFilter = () => {
    setFilterOpen(!isFilterOpen);
  };

  const fetchMapData = () => {
    setIsDataLoading(true);
    setMapDataAPIError("");
    const productArray = [];

    // selectedProduct?.map((product) => {
    //   if (product.value !== "*") productArray.push(parseInt(product.value, 10));
    // });
    selectedProduct?.map((product) => {
      productArray.push(parseInt(product.id, 10));
    });

    const siteStatusArray = [];
    selectedSiteStatus?.map((status) => {
      if (status.value !== "*")
        siteStatusArray.push(parseInt(status.value, 10));
    });

    const siteClientsArray = [];
    selectedClient?.map((client) => {
      siteClientsArray.push(parseInt(client.id, 10));
    });

    const siteIdArray = [];
    selectedSite?.map((site) => {
      siteIdArray.push(parseInt(site.id, 10));
    });

    const subCategoryArray = [];
    selectedSubCategory?.map((category) => {
      if (category.value !== "*")
        subCategoryArray.push(parseInt(category.value, 10));
    });

    const supplierArray = [];
    selectedSupplier?.map((supplier) => {
      supplierArray.push(parseInt(supplier.id, 10));
    });

    const countryArray =
      countryIdList?.length > 0 ? countryIdList : [countryId];

    axios
      .get(
        `/general/search/map?entityTypes=${JSON.stringify(
          entityType
        )}&products=${JSON.stringify(
          productArray
        )}&enquiryTypes=${JSON.stringify(
          serviceType
        )}&siteStatus=${JSON.stringify(
          siteStatusArray
        )}&siteClients=${JSON.stringify(
          siteClientsArray
        )}&siteId=${JSON.stringify(
          siteIdArray
        )}&centreSubCategories=${JSON.stringify(
          subCategoryArray
        )}&suppliers=${JSON.stringify(
          supplierArray
        )}&countryId=${JSON.stringify(countryArray)}`
      )
      .then((response) => {
        setMapData([response.data]);
        setFilterOpen(false);
        setIsDataLoading(false);
      })
      .catch((error) => handleApiError(error));
  };
  const onSubmit = () => {
    if (countryIdList?.length === 0) {
      setCountryIdList([countryId]);
    }
    fetchMapData();
  };

  useEffect(() => {
    fetchMapData();
  }, []);

  useEffect(() => {
    if (generalParams?.coordinates?.longitude) {
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: process.env.REACT_APP_MAPBOX_STYLE_ID,
        center: [
          generalParams?.coordinates?.longitude,
          generalParams?.coordinates?.latitude,
        ],
        zoom: 4,
      });

      map.on("load", () => {
        // -----------------------------------------
        // LOAD CUSTOM IMAGE
        // -----------------------------------------

        map.loadImage(mapSiteIcon, (error, image) => {
          if (error) {
            console.error(error);
            return;
          }

          if (!map.hasImage("site-icon")) {
            map.addImage("site-icon", image);
          }

          map.loadImage(mapCenterIcon, (error, image) => {
            if (!map.hasImage("center-icon")) {
              map.addImage("center-icon", image);
            }
          });
          addLayers();
        });

        const siteGeojsonData = {
          type: "FeatureCollection",
          features:
            mapData?.flatMap(
              (group) =>
                group?.sites?.map((site) => ({
                  type: "Feature",
                  properties: site,
                  geometry: {
                    type: "Point",
                    coordinates: [
                      Number(site.address?.position?.longitude),
                      Number(site.address?.position?.latitude),
                    ],
                  },
                })) || []
            ) || [],
        };

        const centresGeojsonData = {
          type: "FeatureCollection",
          features:
            mapData?.flatMap(
              (group) =>
                group?.centres?.map((centre) => ({
                  type: "Feature",
                  properties: centre,
                  geometry: {
                    type: "Point",
                    coordinates: [
                      Number(centre.address?.position?.longitude),
                      Number(centre.address?.position?.latitude),
                    ],
                  },
                })) || []
            ) || [],
        };

        // -----------------------------------------
        // ADD ALL SOURCES + LAYERS
        // -----------------------------------------

        const addLayers = () => {
          // =====================================
          // SOURCE 1
          // =====================================

          map.addSource("dataset-1", {
            type: "geojson",
            data: siteGeojsonData,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50,
          });

          // CLUSTERS

          map.addLayer({
            id: "clusters-1",
            type: "circle",
            source: "dataset-1",
            filter: ["has", "point_count"],
            paint: {
              // "circle-color": "#8bb8d2",
              "circle-color": [
                "step",
                ["get", "point_count"],
                "#8bb7d3",
                20,
                "#4ca1dd",
                100,
                "#3d75a2",
              ],
              "circle-stroke-color": [
                "step",
                ["get", "point_count"],
                "#a6becd",
                20,
                "#7eb4db",
                100,
                "#517a9b",
              ],
              "circle-radius": 18,
              "circle-blur": 0.1,
              "circle-emissive-strength": 1.5,
              "circle-opacity": 1,
              // "circle-stroke-color": "#a2cdd4",
              "circle-stroke-width": 5,
            },
          });

          // CLUSTER COUNT

          map.addLayer({
            id: "cluster-count-1",
            type: "symbol",
            source: "dataset-1",
            filter: ["has", "point_count"],
            layout: {
              "text-field": ["get", "point_count_abbreviated"],
              "text-size": 14,
            },
          });

          // NON CLUSTER MARKERS

          map.addLayer({
            id: "unclustered-1",
            type: "symbol",
            source: "dataset-1",
            filter: ["!", ["has", "point_count"]],
            layout: {
              "icon-image": "site-icon",
              "icon-size": 1.3,
              "icon-allow-overlap": true,
            },
          });

          // =====================================
          // SOURCE 2
          // =====================================

          map.addSource("dataset-2", {
            type: "geojson",
            data: centresGeojsonData,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50,
          });

          map.addLayer({
            id: "clusters-2",
            type: "circle",
            source: "dataset-2",
            filter: ["has", "point_count"],
            paint: {
              // "circle-color": "#e98659",
              "circle-color": [
                "step",
                ["get", "point_count"],
                "#ecb293",
                20,
                "#ea9065",
                100,
                "#f07037",
              ],
              "circle-stroke-color": [
                "step",
                ["get", "point_count"],
                "#ebc3ae",
                20,
                "#e2a689",
                100,
                "#f08d61",
              ],
              "circle-radius": 18,
              "circle-blur": 0.1,
              "circle-emissive-strength": 1.5,
              "circle-opacity": 1,
              // "circle-stroke-color": "#e9a685",
              "circle-stroke-width": 5,
            },
          });

          map.addLayer({
            id: "cluster-count-2",
            type: "symbol",
            source: "dataset-2",
            filter: ["has", "point_count"],
            layout: {
              "text-field": ["get", "point_count_abbreviated"],
              "text-size": 14,
            },
          });

          map.addLayer({
            id: "unclustered-2",
            type: "symbol",
            source: "dataset-2",
            filter: ["!", ["has", "point_count"]],
            layout: {
              "icon-image": "center-icon",
              "icon-size": 1.3,
              "icon-allow-overlap": true,
            },
          });

          // =====================================
          // POPUPS
          // =====================================

          const addSitePopup = (layerId) => {
            map.on("click", layerId, (e) => {
              const feature = e.features?.[0];

              if (!feature) return;

              const coordinates = feature.geometry.coordinates.slice();

              const siteInfo = feature.properties;
              const enquiryList = JSON.parse(siteInfo.enquiries);
              const addressInfo = addressSingleLine(
                JSON.parse(siteInfo.platformCountry)?.id,
                JSON.parse(siteInfo.address),
                countryList
              );

              let requestContent = "";
              if (enquiryList?.length > 0) {
                requestContent += `<div class="general-map__title-info general-map__dark-blue" style="margin-bottom: 5px; margin-top: 10px;">
                  ${t("ENQUIRIES")}
                </div>`;

                enquiryList?.map((enquiry) => {
                  requestContent += `<div class="general-map__product-info">
                <span class="general-map__disc-info"><a style="font-style: italic; font-weight: 700; text-decoration: underline; outline: 0 !important; color: #474747" target="_blank" href="/site/view/${
                  siteInfo.id
                }/enquiry-view-${enquiry.id}"># ${enquiry.id}</a>
                - ${t(enquiry.service)} - ${enquiry.product.name} - ${
                    enquiry.quantity
                  } ${t(enquiry.unit)}
                </span>
                </div>`;
                });
              }

              const siteStatusList = siteStatus(t);
              const siteStatusInfo = siteStatusList.find(
                (i) => Number(i.value) === Number(siteInfo.status)
              );

              const siteContent = `<div class="general-map__map-popup-outer">
                                    <div class="general-map__title-info general-map__light-blue">
                                      <a target="_blank" style="text-decoration: underline; outline: 0 !important; " href="/site/view/${
                                        siteInfo.id
                                      }/general-info">
                                      # ${siteInfo.id} - ${siteInfo.name} 
                                      </a>
                                    </div>
                                    <div style="display:grid; grid-template-columns: 1fr auto; margin-bottom: 10px;">
                                      <div class="general-map__company-info general-map__grey">
                                        ${JSON.parse(siteInfo.company).name} 
                                      </div>
                                      <div class="general-map__button-wrapper">
                                        <button class="general-map__button"
                                        style="border: 1px solid ${
                                          siteStatusColor[siteStatusInfo.value]
                                        };background: ${
                siteStatusColor[siteStatusInfo.value]
              };">${t(siteStatusInfo.label)}</button>
                                      </div>
                                    </div>
                                    <div  class="general-map__address-info">${addressInfo}</div>
                                    <div  class="general-map__address-info"> ${t(
                                      "SITE_ESTIMATED_DATES"
                                    )}: 
                                    ${getDateFormat(siteInfo.estimatedStartDate,"YYYY-MM-DD")} - 
                                    ${getDateFormat(siteInfo.estimatedEndDate,"YYYY-MM-DD")} 
                                    </div>
                                    ${requestContent}
                                </div>
                            `;

              new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(siteContent)
                .addTo(map);
            });

            map.on("mouseenter", layerId, () => {
              map.getCanvas().style.cursor = "pointer";
            });

            map.on("mouseleave", layerId, () => {
              map.getCanvas().style.cursor = "";
            });
          };

          const addCenterPopup = (layerId) => {
            map.on("click", layerId, (e) => {
              const feature = e.features[0];

              const coordinates = feature.geometry.coordinates.slice();

              const centreInfo = feature.properties;

              const centreList = JSON.parse(centreInfo.centreProducts);

              const supplierInfo = JSON.parse(centreInfo.supplier);

              let productContent = "";
              if (centreList?.length > 0) {
                productContent += `<div class="general-map__title-info general-map__dark-blue" style="margin-bottom: 5px; margin-top: 10px;">
                  ${t("PRODUCTS")}
                </div>`;

                centreList?.map((centre) => {
                  productContent += `<div class="general-map__product-info">
                <span class="general-map__disc-info"><a style="font-style: italic; font-weight: 700; text-decoration: underline; color: #474747; outline: 0 !important; " target="_blank" href="/company/view/${
                  centreInfo.id
                }/center/${centreInfo.centerId}/product/view/${centre.id}"># ${
                    centre.id
                  }</a>
                - ${t(centre.serviceType)} - ${centre.product.name} (${
                    centre.prices
                  } ${t("PRICES")})
                </span>
                </div>`;
                });
              }

              const centreContent = `<div class="general-map__map-popup-outer">
                                    <div class="general-map__title-info general-map__light-orange">
                                      <a target="_blank" style="text-decoration: underline; outline: 0 !important; " href="/company/view/${centreInfo.id}/general-info">
                                      # ${centreInfo.id} - ${centreInfo.name} 
                                      </a>
                                    </div>
                                    <div class="general-map__company-info general-map__grey">
                                      ${supplierInfo?.name} 
                                    </div>
                                    ${productContent}
                                </div>
                            `;

              new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(centreContent)
                .addTo(map);
            });

            map.on("mouseenter", layerId, () => {
              map.getCanvas().style.cursor = "pointer";
            });

            map.on("mouseleave", layerId, () => {
              map.getCanvas().style.cursor = "";
            });
          };

          addSitePopup("unclustered-1");
          addCenterPopup("unclustered-2");

          // =====================================
          // CLUSTER CLICK ZOOM
          // =====================================

          const addClusterZoom = (clusterLayerId, sourceId) => {
            map.on("click", clusterLayerId, (e) => {
              const features = map.queryRenderedFeatures(e.point, {
                layers: [clusterLayerId],
              });

              const clusterId = features[0].properties.cluster_id;

              const source = map.getSource(sourceId);

              source.getClusterExpansionZoom(clusterId, (err, zoom) => {
                if (err) {
                  return;
                }

                map.easeTo({
                  center: features[0].geometry.coordinates,
                  zoom,
                });
              });
            });
          };

          addClusterZoom("clusters-1", "dataset-1");

          addClusterZoom("clusters-2", "dataset-2");
        };
      });

      return () => {
        map.remove();
      };
    }
  }, [mapData]);

  return (
    <MapContainerSection className="general-map">
      <MainTitle>{t("MAP_TITLE")}</MainTitle>
      <MapContainerOuter>
        {isDataLoading && (
          <GridRow column="1fr" marginBottom="0px">
            <GridLoaderItem>
              <PulseLoader width="100%" color="#1bace4" />
            </GridLoaderItem>
          </GridRow>
        )}
        <MapContainer id="map" ref={mapContainer} />
        <FilterOuter>
          {!isFilterOpen && (
            <FitlerOuterDiv>
              <GridRow column="auto 1fr" marginBottom="0px">
                <FilterTitle>{t("FILTERS")}</FilterTitle>
                <Image
                  src={greyIcon}
                  className="general-map__general-icon"
                  onClick={toggleFilter}
                />
              </GridRow>
            </FitlerOuterDiv>
          )}
          {isFilterOpen && (
            <FitlerOuterDiv>
              <FitlerInnerDiv>
                <GridRow column="1fr auto" marginBottom="0px">
                  <FilterTitle color="#0A4986">{t("FILTERS")}</FilterTitle>
                  <Image
                    src={blueCloseArrowIcon}
                    className="general-map__general-icon"
                    onClick={toggleFilter}
                  />
                </GridRow>
                {platfromCountryList?.length > 1 && (
                  <>
                    <GridRow column="1fr" marginBottom="0px">
                      <FlexRow>
                        <Title>{t("COUNTRIES")}</Title>
                      </FlexRow>
                    </GridRow>
                    <GridRow column="1fr">
                      <FlexRow>
                        {platfromCountryList?.map((info, infoIndex) => {
                          return (
                            <BorderImage
                              border={getBorderColor(info.value)}
                              key={
                                "map_search_country" +
                                infoIndex +
                                "=" +
                                info.value
                              }
                            >
                              <Image
                                src={
                                  flagIcons[info.value]
                                    ? flagIcons[info.value]
                                    : defaultCountryFlag
                                }
                                alt="Avatar"
                                styles={{ width: "20px" }}
                                onClick={() => onCountryUpdate(info.value)}
                              />
                            </BorderImage>
                          );
                        })}
                      </FlexRow>
                    </GridRow>
                  </>
                )}

                <GridRow column="1fr" marginBottom="0px">
                  <FlexRow>
                    <Title>{t("MAP_FILTER_ENTITY_TYPE")}</Title>
                  </FlexRow>
                </GridRow>
                <GridRow column="1fr 1fr">
                  {entityTypeOptions.map((type) => (
                    <CustomCheckBox
                      key={`${type.id}${"-"}${type.name}`}
                      id={type.id}
                      labelText={t(type.name)}
                      dataId={type.id}
                      checked={entityType.indexOf(type.id) !== -1}
                      onChange={(e) => {
                        onEntityClick(e, type.id);
                      }}
                    />
                  ))}
                </GridRow>
                {/* <GridRow>
                  <div className="general-map__dropdown">
                    <DropdownWithSearch
                      placeholder={t("MAP_FILTER_PRODUCTS")}
                      label={t("MAP_FILTER_PRODUCTS")}
                      value={selectedProduct}
                      options={productList}
                      isMulti
                      onChange={onProductChange}
                      labelStyles={labelStyles}
                      inputClass="dropdown-with-search__dropdown-type"
                    />
                  </div>
                </GridRow> */}
                <GridRow column="1fr">
                  <div>
                    <ProductFilter
                      selectedProduct={selectedProduct}
                      setSelectedProduct={setSelectedProduct}
                      countryIdList={countryIdList}
                      countryId={countryId}
                    />
                  </div>
                </GridRow>
                {entityType.indexOf("site") !== -1 && (
                  <GridRow>
                    <FilterContainer>
                      <GridRow column="1fr" marginBottom="0px">
                        <FlexRow>
                          <Image
                            src={mapBlueIcon}
                            alt={t("MAP_FILTER_SECTION_SITES")}
                            title={t("MAP_FILTER_SECTION_SITES")}
                            className="general-map__image-icon-map"
                          />
                          <Title>{t("MAP_FILTER_SECTION_SITES")}</Title>
                        </FlexRow>
                      </GridRow>
                      <GridRow column="1fr" marginBottom="5px">
                        <ContainerLabel marginTop="10px">
                          {t("MAP_FILTER_ENQUIRY_TYPE")}
                        </ContainerLabel>
                      </GridRow>
                      <GridRow column="1fr 1fr 1fr">
                        {serviceTypeOptions.map((type) => (
                          <CustomCheckBox
                            key={`${type.value}${"-"}${type.name}`}
                            id={type.value}
                            labelText={t(type.name)}
                            dataId={type.id}
                            checked={serviceType.indexOf(type.value) !== -1}
                            onChange={(e) => {
                              onServiceClick(e, type.value);
                            }}
                          />
                        ))}
                      </GridRow>
                      <GridRow>
                        <div className="general-map__dropdown">
                          <DropdownWithSearch
                            placeholder={t("MAP_FILTER_SITE_STATUS")}
                            label={t("MAP_FILTER_SITE_STATUS")}
                            value={selectedSiteStatus}
                            options={siteStatus(t)}
                            isMulti
                            onChange={onSiteStatusChange}
                            labelStyles={labelStyles}
                            inputClass="dropdown-with-search__dropdown-type"
                          />
                        </div>
                      </GridRow>
                      <GridRow column="1fr">
                        <div>
                          <ClientFilter
                            selectedClient={selectedClient}
                            setSelectedClient={setSelectedClient}
                            countryIdList={countryIdList}
                            countryId={countryId}
                          />
                        </div>
                      </GridRow>
                      <GridRow column="1fr">
                        <div>
                          <SiteFilter
                            selectedSite={selectedSite}
                            setSelectedSite={setSelectedSite}
                            countryIdList={countryIdList}
                            countryId={countryId}
                          />
                        </div>
                      </GridRow>
                    </FilterContainer>
                  </GridRow>
                )}
                {entityType.indexOf("centre") !== -1 && (
                  <GridRow>
                    <FilterContainer>
                      <GridRow column="1fr" marginBottom="0px">
                        <FlexRow>
                          <Image
                            src={mapOrangeIcon}
                            alt={t("MAP_FILTER_SECTION_CENTRES")}
                            title={t("MAP_FILTER_SECTION_CENTRES")}
                            className="general-map__image-icon-map"
                          />
                          <Title color="#F08046">
                            {t("MAP_FILTER_SECTION_CENTRES")}
                          </Title>
                        </FlexRow>
                      </GridRow>
                      <GridRow>
                        <div className="general-map__dropdown">
                          <DropdownWithSearch
                            placeholder={t("MAP_FILTER_SUBCATEGORIES")}
                            label={t("MAP_FILTER_SUBCATEGORIES")}
                            value={selectedSubCategory}
                            options={subCategoryList}
                            isMulti
                            onChange={onSubCategoryChange}
                            labelStyles={labelStyles}
                            inputClass="dropdown-with-search__dropdown-type"
                          />
                        </div>
                      </GridRow>
                      <GridRow column="1fr">
                        <div>
                          <SupplierFilter
                            selectedSupplier={selectedSupplier}
                            setSelectedSupplier={setSelectedSupplier}
                            countryIdList={countryIdList}
                            countryId={countryId}
                          />
                        </div>
                      </GridRow>
                    </FilterContainer>
                  </GridRow>
                )}
              </FitlerInnerDiv>
              <ButtonWrapper>
                {mapDataAPIError && <div>{mapDataAPIError}</div>}
                <Button
                  styles={{
                    color: "white",
                    background: "#1BACE4",
                    border: "1px solid #1BACE4",
                    marginRight: "0.32rem",
                    "&:hover": {
                      backgroundColor: "#1589b6",
                    },
                  }}
                  disabled={entityType?.length === 0}
                  onClick={onSubmit}
                >
                  <>
                    {isDataLoading && <ClipLoader size={15} color="#fff" />}
                    {!isDataLoading && t("MAP_FILTER_ACTION_FILTER")}
                  </>
                </Button>
              </ButtonWrapper>
            </FitlerOuterDiv>
          )}
        </FilterOuter>
      </MapContainerOuter>
    </MapContainerSection>
  );
};

GeneralMap.propTypes = {
  t: PropTypes.func.isRequired,
};

GeneralMap.defaultProps = {};

export default withTranslation()(GeneralMap);
